import React, { useContext } from 'react';
import { Message } from 'src/services/ai-insights/AIInsightsState';

/**
 * One conversation's state, as produced by useAIInsightChat.
 *
 * Scoped per conversation rather than per app: AIInsightPanel provides it, so each open panel
 * has its own transcript. The app-wide concerns (feature flag, signed-in user, service) live
 * in AIInsightsContext instead.
 */
export interface AIInsightChatContextType {
    messages: Message[];
    loading: boolean;
    error: string;
    pollingReportId?: string;
    pollingElapsed: number;
    sendMessage: (message: string) => void;
}

export const AIInsightChatContext = React.createContext<AIInsightChatContextType | null>(null);

/**
 * Reads the conversation state. Throws when no provider is mounted, since a chat component
 * rendered outside a conversation is a wiring mistake rather than a state to degrade into.
 */
export function useAIInsightChatContext(): AIInsightChatContextType {
    const context = useContext(AIInsightChatContext);
    if (!context) {
        throw new Error('useAIInsightChatContext must be used within an AIInsightChatContext.Provider');
    }
    return context;
}
